import RedesignedModal from "../../common/RedesignedModal";
import { CPButton, CustomisedTertiaryButton, Wrapper } from "../../../constants/common/StyledGlobalConstants";
import { setCreateCaseAPIFailure } from "../../../store/actions/schedulingportal/technicianAppointment";
import { useDispatch } from "react-redux";
import { getPendoId } from "../../../util/cfstPendoUtils";
import PropTypes from "prop-types";

function DeleteServiceModal({ isDeleteservice, deleteService, reTriggerCreateCaseAPI, isCreateCaseAPIFailed }) {
  const dispatch = useDispatch();
  return (
    <RedesignedModal
      opened={true}
      closeIconId={
        isCreateCaseAPIFailed ? getPendoId("something-went-wrong-modal-close-icon-button") : getPendoId("delete-service-modal-close-icon-button")
      }
      onClickClose={() => {
        if (isCreateCaseAPIFailed) {
          dispatch(setCreateCaseAPIFailure(false));
        } else {
          deleteService(-1, true);
        }
      }}
      zIndex={"1001"}
      title={isCreateCaseAPIFailed ? "Something went wrong" : "Delete service?"}
      ModalAriaLabel={isCreateCaseAPIFailed ? "Something went wrong" : "Delete service modal"}
      button={
        <>
          <CustomisedTertiaryButton
            ariaLabel="Cancel"
            onClick={() => {
              if (isCreateCaseAPIFailed) {
                dispatch(setCreateCaseAPIFailure(false));
              } else {
                deleteService(-1, true);
              }
            }}
            buttonWidth={"100%"}
            buttonHeight={"40px"}
            fontSize={"14px"}
            id={isCreateCaseAPIFailed ? getPendoId("something-went-wrong-modal-cancel-button") : getPendoId("delete-service-modal-cancel-button")}
          >
            {`CANCEL`}
          </CustomisedTertiaryButton>
          <CPButton
            width="autoTight"
            id={isCreateCaseAPIFailed ? getPendoId("something-went-wrong-modal-tryagain-button") : getPendoId("delete-service-modal-delete-button")}
            buttonHeight={"40px"}
            buttonWidth={"100%"}
            ariaLabel={isCreateCaseAPIFailed ? "Try again" : "Delete"}
            boxButton={true}
            onClick={() => {
              if (isCreateCaseAPIFailed) {
                reTriggerCreateCaseAPI();
              } else {
                deleteService(isDeleteservice.index);
              }
            }}
            style={{ height: "2.5rem" }}
            fontSize={"14px"}
          >
            {isCreateCaseAPIFailed ? "TRY AGAIN" : `DELETE`}
          </CPButton>
        </>
      }
    >
      <Wrapper fontFamily="neue-haas-grotesk-text" fontStyle="normal" fontWeight="400" fontSize="14px" marginBottom="0" marginTop="0">
        {isCreateCaseAPIFailed ? "An appointment was not created." : "All the information you have entered about this appointment will be lost."}
      </Wrapper>
    </RedesignedModal>
  );
};

DeleteServiceModal.propTypes = {
  isDeleteservice: PropTypes.oneOfType([
    PropTypes.shape({
      index: PropTypes.number,
    }),
    PropTypes.bool,
  ]).isRequired,
  deleteService: PropTypes.func.isRequired,
  reTriggerCreateCaseAPI: PropTypes.func.isRequired,
  isCreateCaseAPIFailed: PropTypes.bool.isRequired,
};

export default DeleteServiceModal;